/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Last_OwnerInputs */

const en_adm_err_last_owner = /** @type {(inputs: Adm_Err_Last_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the last active owner. Make someone else an owner first.`)
};

const de_adm_err_last_owner = /** @type {(inputs: Adm_Err_Last_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist der letzte aktive Eigentümer. Mach zuerst jemand anderen zum Eigentümer.`)
};

/**
* | output |
* | --- |
* | "This is the last active owner. Make someone else an owner first." |
*
* @param {Adm_Err_Last_OwnerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_last_owner = /** @type {((inputs?: Adm_Err_Last_OwnerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Last_OwnerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_last_owner(inputs)
	return en_adm_err_last_owner(inputs)
});